import React, {useContext, useState, useEffect} from 'react';

import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import PlanetInfo from '../PlanetInfo';

import _firebaseContext from '../../../contexts/firebaseContext';
import _appContext from '../../../contexts/appContext';

export default function PlanetsPanel() {
    const classes = useStyles();

    const firebaseContext = useContext(_firebaseContext);
    const appContext = useContext(_appContext);

    const matches = useMediaQuery('(max-width:767px)');
    const [currentPlanetIndex, setCurrentPlanetIndex] = useState(0);

    useEffect(() => {
        return () => {
            firebaseContext.closeTracksListener()
        };
    }, [currentPlanetIndex]);

    useEffect(() => {
        firebaseContext.startPlanetListener();

        return () => {
            firebaseContext.closePlanetListener();
        }
    }, [])

    let planets = firebaseContext.data.planets;

    useEffect(() => {
        planets = firebaseContext.data.planets;

        if (firebaseContext.data.fetchingState.planets ||
            firebaseContext.data.fetchingState.history ||
            firebaseContext.data.fetchingState.tracks) {
            appContext.startLoading();
        } else {
            appContext.endLoading();
        }
    });

    // const handleAddPlanetBtnClick = async event => {
    //     const testPlanet = {
    //         name: 'new Planet'
    //     };
    //     const result = await firebaseContext.addPlanet(testPlanet);

    //     appContext.snackbar.showSnackbarMsg(result.message);
    // }

    return (
        <div className={classes.root}>
            <div className={classes.planetsListTitle}>
                <Typography
                    className={classes.tabsTitle}
                    color="textSecondary"
                >
                    Список планет
                </Typography>
                {/* <IconButton
                    edge="end"
                    // disabled={true}
                    onClick={handleAddPlanetBtnClick}>
                    <PlaylistAddIcon />
                </IconButton> */}
            </div>

            <div className={`${classes.tabsWrapper} ${matches ? classes.column : classes.row}`}>
                {
                    planets.length === 0 ? (
                        <Typography variant="body1">
                            В системе пока нет планет
                        </Typography>
                    ) : (
                        <>
                            <Tabs
                                orientation={matches ? "horizontal" : "vertical"}
                                variant="scrollable"
                                onChange={(event, value) => setCurrentPlanetIndex(value)}
                                value={currentPlanetIndex}
                                className={classes.tabs}
                            >
                                {
                                    firebaseContext.data.planets.map((planet, i) => (
                                        <Tab key={planet.id}
                                             label={`${planet.data.name}${planet.data.disabled ? ' (отключена)' : ''}`}/>
                                    ))
                                }
                            </Tabs>
                            <PlanetInfo planet={planets[currentPlanetIndex]} key={planets[currentPlanetIndex].id}/>
                        </>
                    )
                }
            </div>
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: 500
    },
    tabsWrapper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
    },
    column: {
        flexDirection: 'column'
    },
    row: {
        flexDirection: 'row'
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
    tabsTitle: {
        display: 'block',
        marginTop: '15px',
        marginBottom: '15px',
    },
    planetsListTitle: {
        display: 'flex',
        alignItems: 'center'
    }
}));
